import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import InlineSvg from "vue-inline-svg";
import { useRoute } from "vue-router";


const __default__ = {
  name: "LostItemGuideModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onClickCloseButton"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const route = useRoute();

/** 이미지 컨테츠 visible 여부 */
const shouldShowModal = ref(true);

const toggleShowModal = (show: boolean) => {
  shouldShowModal.value = show;
};

const handleClickClosebutton = () => {
  route.meta.onBackHandlerList.pop();
  toggleShowModal(false);

  setTimeout(() => {
    emit("onClickCloseButton");
  }, 300);
};

onMounted(() => {
  route.meta.onBackHandlerList.push(handleClickClosebutton);
});

const __returned__ = { emit, route, shouldShowModal, toggleShowModal, handleClickClosebutton, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})